import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import getPageTitle from "@/utils/get-page-title";
import LoadScript from "vue-plugin-load-script";
// import 'bootstrap';

Vue.use(LoadScript);

// import "./lib/CustomCss";

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = getPageTitle(to.meta.title);
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
